// extracted by mini-css-extract-plugin
module.exports = {"confirmContainer":"styles_confirmContainer__1olmK","confirmHeader":"styles_confirmHeader__1BBqI","resendLink":"styles_resendLink__28xrr"};